import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FiltrosCPE } from 'app/models/FiltrosCPE';
import { DatePipe } from '@angular/common';
import { FacturacionCPEService } from 'app/services/facturacion-cpe/facturacion-cpe.service';
import { FormGroup} from '@angular/forms';
import * as moment from 'moment';
import { MessagesTitles, MessagesStatus } from 'app/models/messages';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import Swal from 'sweetalert2';
import { EmpresasService } from 'app/services/empresas/empresas.service';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-detalle-nota-cpe',
  templateUrl: './detalle-nota-cpe.component.html',
  styleUrls: ['./detalle-nota-cpe.component.scss'],
  providers:[MessagesTitles, MessagesStatus,DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class DetalleNotaCpeComponent implements OnInit {

  DTOFiltrosCPE: FiltrosCPE = new FiltrosCPE();

  ruta : string;
  Fecha_Emision: Date = new Date();
  FechaFin: Date = new Date();
  Monto: number;
  form : FormGroup;
  now = moment();
  loading:boolean;
  facturas : any = [];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns=[ 'checked','Razon_Social','Numero','Fecha_Emision']
  dataSource: any;

  @Output() cerrarDetalle = new EventEmitter<boolean>();
  @Output() dataDetalle = new EventEmitter<boolean>();
  
  constructor(private datePipe:DatePipe,private cpeService:FacturacionCPEService) {}

  ngOnInit() {
    this.ListadoFacturaDetail();
  }

ListadoFacturaDetail(){
  this.Fecha_Emision = this.cpeService.DataBuscar.Fecha_Referente;
  this.loading = true;

  this.DTOFiltrosCPE.Tipo_Comprobante_CPE = 'F';
  this.DTOFiltrosCPE.Serie = this.cpeService.DataBuscar.Serie_Referente;
  this.DTOFiltrosCPE.NumeroFact = this.cpeService.DataBuscar.Numero_Referente;

  this.ListadoFactura();
}

ListadoFactura(){
 this.loading = true;
 this.cpeService.FiltrosListadoFacturaDetail(this.DTOFiltrosCPE, this.datePipe.transform(this.Fecha_Emision,'yyyy-MM-dd')).subscribe(
   res =>{
       this.facturas = res['data'];
       this.dataSource = new MatTableDataSource(this.facturas);
       this.dataSource.sort = this.sort;
       this.dataSource.paginator = this.paginator;
       this.loading = false;
   },err =>{
       Swal.fire({
           title: "¡Algo salió mal!",
           text:  err.error['error'],
           type: "warning",
           allowOutsideClick: true,
           heightAuto: false 
       });
       this.loading = false;
   }
 )
}



Enviar(elemento:any){
  this.cpeService.dataFactura = elemento;
  this.cerrarDetalle.emit();
  this.dataDetalle.emit();

}

  CerrarPopUp() {
    this.cerrarDetalle.emit();
  }

}
